import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from 'shared/errors';
import {
  TAddOfferToComparisonRequest,
  TAddOfferToComparisonResponse,
  fetchAddOfferToComparison,
} from 'shared/repositories/offers-comparison/v2/add-offer-to-comparison';

export const addToComparison = async (
  { httpApi, logger }: IApplicationContext,
  parameters: TAddOfferToComparisonRequest,
) => {
  try {
    const { response, statusCode }: TAddOfferToComparisonResponse = await fetchAddOfferToComparison({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'addToComparison',
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return response;
  } catch (e) {
    logger.error(e, {
      domain: 'addToComparison',
      parameters: JSON.stringify(parameters),
    });

    return null;
  }
};
